import { render, staticRenderFns } from "./top-bar-actions.vue?vue&type=template&id=b19e9904"
import script from "./top-bar-actions.vue?vue&type=script&lang=js"
export * from "./top-bar-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports